import { defineComponent as h, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as V, createElementVNode as l, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const M = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, m = { key: 3 }, f = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconTrashSimple"
}, _ = /* @__PURE__ */ h({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = u(r);
    return (d, a) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      V(d.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", M, a[0] || (a[0] = [
        l("path", { d: "M216,48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM188,204H68V72H188ZM76,20A12,12,0,0,1,88,8h80a12,12,0,0,1,0,24H88A12,12,0,0,1,76,20Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", Z, a[1] || (a[1] = [
        l("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M216,48H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM192,208H64V64H192ZM80,24a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H88A8,8,0,0,1,80,24Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        l("path", { d: "M224,56a8,8,0,0,1-8,8h-8V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,56ZM88,32h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", m, a[3] || (a[3] = [
        l("path", { d: "M216,50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM82,24a6,6,0,0,1,6-6h80a6,6,0,0,1,0,12H88A6,6,0,0,1,82,24Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", f, a[4] || (a[4] = [
        l("path", { d: "M216,48H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM192,208H64V64H192ZM80,24a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H88A8,8,0,0,1,80,24Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        l("path", { d: "M216,52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM84,24a4,4,0,0,1,4-4h80a4,4,0,0,1,0,8H88A4,4,0,0,1,84,24Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
